import { createContext, useContext } from 'react';

// Сам контекст и хук к нему — отдельно от провайдера.
//
// Провайдер ходит на сервер, а значит тянет за собой весь слой запросов.
// Карточке, чек-листу и точкам-подсказкам нужно только прочитать состояние,
// поэтому они берут его отсюда и остаются лёгкими — их видно в тестах без
// поднятого приложения.

const OnboardingContext = createContext(null);

// Хук работает и без провайдера — тогда отдаёт заглушку. Так страницу можно
// рендерить в тесте, не оборачивая её в провайдер.
const EMPTY = {
  available: false,
  tourRunning: false,
  startTour: () => {},
  finishTour: () => {},
  checklistDone: [],
  checklistHidden: true,
  completeChecklistItem: () => {},
  hideChecklist: () => {},
  restartOnboarding: () => {},
  allChecklistDone: false,
};

export const useOnboarding = () => useContext(OnboardingContext) || EMPTY;

export default OnboardingContext;
